import { inject } from "mobx-react";
import * as React from "react";
import { UitkFigure, UitkImage } from "uitk-react-images";

import { AspectRatioEnum, ThumborStore } from "stores/thumbor/ThumborStore";
import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";

export interface HeroImageProps {
  src: string;
  alt: string;
  className?: string;
  context: ExtendedContextStore;
  thumbor?: ThumborStore;
}

export const HeroImage: React.FC<HeroImageProps> = inject("thumbor")(
  ({ context, thumbor, src, alt, children, className = "" }) => {
    const imageSrc = thumbor
      ? thumbor.safelyGenerateThumborizedImageUrl(src, 1680, 600, context, AspectRatioEnum.R_21_9, true, 87)
      : src;

    return (
      <UitkFigure className={className}>
        <UitkImage alt={alt} src={imageSrc} className="bexHeroImageBackground" />
        {children}
      </UitkFigure>
    );
  }
);
